import React from 'react';
import {add, isBefore, sub} from "date-fns";
import getTagValue from "./get-tag-value";
import {isSet} from "../utility";
import {COUNTDOWN_CONSTRAINTS, ENTITY_TYPE, OUT_NEGATIVE, OUT_POSITIVE} from "../constants";
import {adopt} from "../math";

const getAvailableEndpoints = ({endpoints, now, showAll = false, hideSendout = true}) => {
    if (showAll) {
        return endpoints;
    }
    return endpoints.filter(e => {
        if (e.labels && (e.labels.isFriendly || e.labels.isFree || e.labels.isPromo) && hideSendout) {
            return false;
        }
        if (!isSet(e.start) && !isSet(e.end) && e.quantity > 0) {
            return true;
        } else {
            const endpointAlwaysVisible = getTagValue(e.tags, 'visibility', {defaultValue: 'hidden'}) === 'visible';
            const isWave = getTagValue(e.tags, 'sellAfter') === 'endpoint';
            const sellEndpointId = getTagValue(e.tags, 'sellEndpointId');
            const previousWave = isWave && sellEndpointId && endpoints.find(el => el.id === sellEndpointId);
            let previousWaveEnded = !!previousWave;
            if (previousWaveEnded) {
                if (isWave && previousWave) {
                    if (previousWave.quantity === 0) {
                        previousWaveEnded = true;
                    } else {
                        const previousWaveEnd = new Date(previousWave.end);
                        previousWaveEnded = isBefore(previousWaveEnd, now);
                    }
                }
            }
            const visibilityCondition = isWave ? previousWaveEnded && e.quantity > 0 : e.quantity > 0;
            const {state} = adopt(now, e.start, e.end, e.strategy, e.every);
            const countdownUnits = COUNTDOWN_CONSTRAINTS[ENTITY_TYPE.endpoint].units;
            const countdownAmount = COUNTDOWN_CONSTRAINTS[ENTITY_TYPE.endpoint].amount;
            if (state === OUT_NEGATIVE && isSet(e.end) && isBefore(add(new Date(e.end), {[countdownUnits]: countdownAmount}), new Date(now))) {
                return endpointAlwaysVisible || false;
            } else if (state === OUT_POSITIVE && isSet(e.start) && isBefore(new Date(now), sub(new Date(e.start), {[countdownUnits]: countdownAmount}))) {
                return endpointAlwaysVisible || false;
            } else {
                return visibilityCondition || endpointAlwaysVisible;
            }
        }
    });
};

export default getAvailableEndpoints;